import { useState, createContext } from 'react'
interface FormContextType {
  formData: object
  handleFormChange: (fieldName: string, value: string) => void
}

export const FormContext = createContext<FormContextType>(null)

export const FormProvider = ({ children }: { children: React.ReactNode }) => {
  const [formData, setFormData] = useState({})

  const handleInputChange = (fieldName, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }))
  }

  return (
    <FormContext.Provider
      value={{ formData, handleFormChange: handleInputChange }}
    >
      {children}
    </FormContext.Provider>
  )
}
